<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" compact="true"></app-side-menu>

<app-nav-bar [sideBar]="false" (navMessage$)="listenerNav($event)"></app-nav-bar>

<app-footer [sideBar]="false"></app-footer>

<div class="content-page">

    @if (contactId > 0) {
    <section class="sticky-toolbar rounded">
        <div class="card">
            <div title="Show Alerts & Notes">
                <notes [module]="'collections,contacts'" [contactId]="contactId" title="Show Alerts & Notes"></notes>
            </div>
        </div>
    </section>
    }

    <div class="content">

        <div class="container-fluid">

            <div class="card-deck">

                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title clickable" (click)="edit($event)">{{contact}}</h2>
                        <p class="card-subtitle text-muted">{{address}}</p>
                        <div class="card-subtitle">
                            @if (phone) {
                            <a href="tel://{{phone}}" class="card-link">{{formattedPhone}}</a>
                            }
                            @if (email) {
                            <a href="mailto:{{email}}" class="card-link">{{email}}</a>
                            }
                        </div>
                        <div class="link-bar">
                            <a href="#" class="card-link" (click)="edit($event)"><span class="material-icons">edit</span></a>
                        </div>
                    </div>
                </div>

                <div class="card due" (click)="payPastDue($event)">
                    <div class="card-body">
                        <span class="material-icons" [class.text-danger]="pastDue > 0">fmd_bad</span>
                        <div>
                            <h2 class="card-title" [class.text-danger]="pastDue > 0">{{pastDue | currency}}</h2>
                            <p class="card-subtitle text-muted">Past due amount {{pastDueSince}}.</p>
                        </div>
                        @if (pastDue > 0) {
                        <button class="btn btn-danger btn-sm">pay</button>
                        }
                    </div>
                </div>

                <div class="card due" (click)="payDueToday($event)">
                    <div class="card-body">
                        <span class="material-icons">today</span>
                        <div>
                            <h2 class="card-title">{{dueToday | currency}}</h2>
                            <p class="card-subtitle text-muted">Total amount due today.</p>
                        </div>
                        @if (dueToday > 0) {
                            <button class="btn btn-light btn-sm">pay</button>
                        }
                    </div>
                </div>
            </div>

            <div class="card-columns">

                <take-payment [contactId]="contactId" [language]="language" [pays]="pays" [allocate]="allocation" [payThisAmount]="payThisAmountEvent" (paymentTaken)="paymentTaken($event)"></take-payment>

                <pays [contactId]="contactId" [language]="language" (paysChanged)="paymentsChanged($event)" [paymentTaken]="paymentTakenEvent"></pays>

                <pay-promises [contactId]="contactId" [language]="language" [pays]="pays" [paymentTaken]="paymentTakenEvent"></pay-promises>

                <receipts [contactId]="contactId" [language]="language" [paymentTaken]="paymentTakenEvent" (refundProcessed)="refunded($event)"></receipts>

                <associations [contactId]="contactId"></associations>

                <gps-devices [contactId]="contactId"></gps-devices>

            </div>

        </div>

    </div>

    <contact-modal [contactId]="contactId" [key]="'collect'" [language]="language" [words]="words" (modified)="contactModified($event)"></contact-modal>
